import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { ToggleButtonStatusSubmenu } from "src/components";
import {
  ActiveIssueStatuses,
  ClosedIssueStatuses,
  ISSUE_STATUSES,
  IssuesFilterByOption,
  IssueStatus,
} from "../../constants";

interface Props {
  filterByOption: IssuesFilterByOption;
  filterByStatusOptions: IssueStatus[] | null;
  onChange: (filterByOption: IssuesFilterByOption, filterByStatusOptions: IssueStatus[] | null) => void;
}

const IssuesFilterToggleButton = (props: Props) => {
  function handleFilterByChanged(value: IssuesFilterByOption) {
    // The status filter option should only be set after a status option is selected from the submenu
    if (value != null && value !== IssuesFilterByOption.Status) {
      props.onChange(value, null);
    }
  }

  function handleFilterByStatusChanged(values: IssueStatus[]) {
    if (values.length === 0) {
      props.onChange(IssuesFilterByOption.All, null);
      return;
    }

    props.onChange(IssuesFilterByOption.Status, values);
  }

  return (
    <>
      <ToggleButtonGroup
        value={props.filterByOption}
        exclusive
        orientation="vertical"
        variant="menu"
        onChange={(_, value) => handleFilterByChanged(value)}
        sx={{ minWidth: "100%" }}
      >
        <ToggleButton value={IssuesFilterByOption.All}>
          <Typography>All</Typography>
        </ToggleButton>

        <ToggleButtonStatusSubmenu
          value={IssuesFilterByOption.Status}
          statuses={ISSUE_STATUSES}
          selectedStatusIds={props.filterByStatusOptions ?? []}
          activeStatusFilter={(status) => ActiveIssueStatuses.includes(status.id)}
          closedStatusFilter={(status) => ClosedIssueStatuses.includes(status.id)}
          onStatusSelected={(selectedStatusIds) => handleFilterByStatusChanged(selectedStatusIds)}
          menuProps={{
            anchorOrigin: {
              horizontal: "left",
              vertical: "top",
            },
            transformOrigin: {
              horizontal: "right",
              vertical: "top",
            },
          }}
        />
      </ToggleButtonGroup>
    </>
  );
};

export { IssuesFilterToggleButton };
